import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { TerminalSummaryPerTerminalType } from 'src/app/@core/domain/interfaces/terminal.interface';

@Component({
  selector: 'app-terminal-type',
  templateUrl: './terminal-type.component.html',
  styleUrls: ['./terminal-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TerminalTypeComponent implements OnInit {
  @Input() summary!: TerminalSummaryPerTerminalType;
  terminalTypeIcon = 'terminalType_0';
  constructor() {}

  ngOnInit(): void {
    const terminalTypeEnumValue = Object.values(this.summary.type)[0];
    this.terminalTypeIcon = 'terminalType_' + terminalTypeEnumValue;
  }
}
